import { LegalPage, LegalSection } from "@/components/layout/LegalPage";
import { useCompanySettings } from "@/context/SettingsContext";

export default function DisclaimerPage() {
  const { settings } = useCompanySettings();
  const co = settings.company_name;
  return (
    <LegalPage title="Disclaimer" subtitle="Last updated: July 2026" testId="disclaimer-page">
      <LegalSection title="1. No Guarantee of Employment">
        <p>
          {co} is a recruitment facilitation platform. While we verify opportunities with reasonable care and support every
          candidate personally, we do not and cannot guarantee job placement, interview selection, salary levels or the
          duration of any employment. All hiring decisions are made solely by the respective employers.
        </p>
      </LegalSection>
      <LegalSection title="2. Hiring Brands">
        <p>
          Job listings display hiring brand descriptions (e.g. “Leading Private Bank”) rather than legal employer names to
          protect client confidentiality. Full employer details are shared with candidates at the appropriate stage of the
          recruitment process.
        </p>
      </LegalSection>
      <LegalSection title="3. We Never Charge Job Seekers">
        <p>
          {co} never charges job seekers any fee at any stage — no registration fee, no placement charges, no hidden charges.
          Anyone demanding money in the name of {co} is committing fraud. Please report such incidents immediately to
          {" "}{settings.support_email || "our support team"}.
        </p>
      </LegalSection>
      <LegalSection title="4. Information Accuracy">
        <p>
          We strive to keep all information on the Platform accurate and up to date. However, job details such as salary
          ranges, locations and requirements are provided by employers and may change without notice.
        </p>
      </LegalSection>
      <LegalSection title="5. External Links">
        <p>
          The Platform may contain links to external websites or services (such as WhatsApp). {co} is not responsible for the
          content, policies or practices of any third-party site or service.
        </p>
      </LegalSection>
    </LegalPage>
  );
}
